import React from "react";

import GuideYear from "../../components_web/guides/component/GuideYear";
import GuideContinent from "../../components_web/guides/component/GuideContinent";
import GuideWorld from "../../components_web/guides/component/GuideWorld";
import { LocationDao } from "../../src/DAO";
import { Constants } from "../../src/config";

export async function getServerSideProps(context) {
  try {
    const { params, query } = context;
    const categoryType =
      process.env.NEXT_PUBLIC_APP_NAME === "Vybeful"
        ? Constants.categoryType.CATEGORY_VENUE
        : process.env.NEXT_PUBLIC_APP_NAME === "RooftopClub"
        ? Constants.categoryType.CATEGORY_ROOFTOP
        : process.env.NEXT_PUBLIC_APP_NAME === "Cocktayl"
        ? Constants.categoryType.CATEGORY_VENUE_COCKTAIL
        : process.env.NEXT_PUBLIC_APP_NAME === "Beachful"
        ? Constants.categoryType.CATEGORY_VENUE_BEACHFUL
        : process.env.NEXT_PUBLIC_APP_NAME === "PrefabWorld"
        ? Constants.categoryType.CATEGORY_PREFAB_COMPANY
        : process.env.NEXT_PUBLIC_APP_NAME === "Zoopedia"
        ? Constants.categoryType.CATEGORY_ZOO
        : process.env.NEXT_PUBLIC_APP_NAME === "Parkful"
        ? Constants.categoryType.CATEGORY_PARKFUL
        : process.env.NEXT_PUBLIC_APP_NAME === "WorldCasino"
        ? Constants.categoryType.CATEGORY_CASINO
        : process.env.NEXT_PUBLIC_APP_NAME === "Castlepedia"
        ? Constants.categoryType.CATEGORY_CASTLE
        : process.env.NEXT_PUBLIC_APP_NAME === "LuxResort Club"
        ? Constants.categoryType.CATEGORY_RESORT
        : process.env.NEXT_PUBLIC_APP_NAME === "AparthotelClub"
        ? Constants.categoryType.CATEGORY_APARTHOTEL
        : process.env.NEXT_PUBLIC_APP_NAME === "SpaClub"
        ? Constants.categoryType.CATEGORY_SPA
        : process.env.NEXT_PUBLIC_APP_NAME === "Festyful"
        ? Constants.categoryType.CATEGORY_FESTIVAL
        : Constants.categoryType.CATEGORY_VENUE;
    const listYear = [2022, 2023, 2024, 2025, 2026];

    let listData = [];
    if (process.env.NEXT_PUBLIC_APP_NAME === "Festyful") {
      for (const year of listYear) {
        const resultData = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "continent",
            year,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });
        // if (resultData.length > 0) {
        listData.push({
          slug: year,
          title: year,
          resultData,
          params: {
            categoryType,
            progFilterType: "continent",
            year,
          },
        });
        // }
      }
    } else {
      if (categoryType === Constants.categoryType.CATEGORY_PREFAB_COMPANY) {
        listData = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "country",
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });
      } else {
        listData = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "continent",
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });
      }
    }

    return {
      props: {
        listData,
      },
    };
  } catch (err) {
    console.error("err", err);
    return {
      notFound: true,
    };
  }
}

const GuideWorldPage = (props) => {
  if (process.env.NEXT_PUBLIC_APP_NAME === "Festyful") {
    return <GuideYear {...props} />;
  } else if (process.env.NEXT_PUBLIC_APP_NAME === "PrefabWorld") {
    return <GuideContinent {...props} continentSelected={null} />;
  } else if (
    process.env.NEXT_PUBLIC_APP_NAME === "Zoopedia" ||
    process.env.NEXT_PUBLIC_APP_NAME === "Parkful" ||
    process.env.NEXT_PUBLIC_APP_NAME === "WorldCasino" ||
    process.env.NEXT_PUBLIC_APP_NAME === "LuxResort Club"
  ) {
    return <GuideWorld {...props} />;
  } else {
    return <GuideWorld {...props} />;
  }
};

export default GuideWorldPage;
